import React, { Dispatch, MutableRefObject, SetStateAction, useEffect, useRef, useState } from 'react'
import appError from '../../../../../appError';
import { Button, Input } from '@mui/joy';
import CondCmpForDbData from './CondCmpForDbData';
import CondCmpForCreate from './CondCmpForCreate';
import { BASE_URL } from '../../../../../appConstants';
import axios from 'axios';

type Condition = {
    metric: string;
    parameter: string;
    // operator?: string;
    initial_value: string;
    dependent_value: string;
    Operation: string;
};
type MatricsProps = {
    id: number;
    matrice_name: string;
    backend_matrice_name: string;
  };
type NewConditionProps = {
    metric: string;
    metric_error?: boolean;
    parameter: string;
    parameter_error?: boolean;
    Operation: string;
    Operation_error?: boolean;
    initial_value: string;
    initial_value_error?: boolean;
    dependent_value: string;
};
type ListProps = {
    condition_name: string;
    condition_array: Condition[];
    condition_id: string;
    dashboard: string;
  };
type ParametersProps = {
    id: number;
    parameter: string;
  };
type OperationProps = {
    id: number;
    operation: string;
  };
type ConditionCompCmpProps = {
    local_Cond_name: string;
    setlocal_Cond_name: React.Dispatch<React.SetStateAction<string>>;
    setlocal_Cond_id: React.Dispatch<React.SetStateAction<string>>;

    conditionsArr: Condition[];
    setConditionsArr: Dispatch<SetStateAction<Condition[]>>;
    localconditions: Condition[];
    setLocalConditions: React.Dispatch<React.SetStateAction<Condition[]>>;
    newconditionsArr: NewConditionProps[];
    setNewConditionsArr: React.Dispatch<React.SetStateAction<NewConditionProps[]>>;
    matricsArr: MatricsProps[];
    parameterArr: ParametersProps[];
    operationsArr: OperationProps[];
    listarr: ListProps[];

    conditionToggle: boolean;
    page_name: string;
    ClearAll: () => void;
    setConditionToggle : React.Dispatch<React.SetStateAction<boolean>>;
    isDbDataChanges: boolean;
    setIsDbDataChanges: React.Dispatch<React.SetStateAction<boolean>>;
    setSaveConditionToggle: React.Dispatch<React.SetStateAction<boolean>>;
    temp_list_name: string;
    setTemp_List_name: React.Dispatch<React.SetStateAction<string>>;
    createConditionLists: () => Promise<void>;
    saveConditionToggle: boolean;
    conditonsSave: boolean;
    setConfirmConditionToggle: React.Dispatch<React.SetStateAction<boolean>>;
}
const ConditionCompCmp: React.FC<ConditionCompCmpProps> = ({
    local_Cond_name,
    setlocal_Cond_name,
    setlocal_Cond_id,

    conditionsArr, 
    setConditionsArr, 
    localconditions,
    setLocalConditions,
    newconditionsArr,
    setNewConditionsArr,
    matricsArr, 
    parameterArr,
    operationsArr,
    listarr,

    conditionToggle,
    page_name,
    ClearAll,
    setConditionToggle,
    isDbDataChanges,
    setIsDbDataChanges,
    setSaveConditionToggle,
    temp_list_name,
    setTemp_List_name,
    createConditionLists,
    saveConditionToggle,
    conditonsSave,
    setConfirmConditionToggle,
    }) => {
        
    const conditonsContainerRef = useRef<HTMLDivElement | null>(null);
    const [localCondToggle, setLocalCondToggle] = useState<boolean>(false);
    const [temp_list_name_error, setTemp_list_name_error] = useState<boolean>(false);
    const [newcondition, setNewCondition] = useState<Condition>({
        metric: "",
        parameter: "",
        Operation: "",
        initial_value: "",
        dependent_value: "",
    });
    let SavedConditionsRef: MutableRefObject<HTMLDivElement | null> = useRef(null);
    let SavedConditionsBtnRef = useRef<HTMLImageElement | null>(null); // Menu button reference

    let ConditionsRef: MutableRefObject<HTMLDivElement | null> = useRef(null);
    let ConditionsBtnRef = useRef<HTMLImageElement | null>(null); // Menu button reference
    
    const SavedConditionshandleClickOutside = (event: MouseEvent) => {
        // Check if the click is outside the dropdown (menuRef)
        if (
          SavedConditionsRef.current &&
          !SavedConditionsRef.current.contains(event.target as Node) &&
          SavedConditionsBtnRef.current &&
          !SavedConditionsBtnRef.current.contains(event.target as Node)
        ) {
          setLocalCondToggle(false); // Close the dropdown if clicked outside
        }
      };
    
    const ConditionshandleClickOutside = (event: MouseEvent) => {
    // Check if the click is outside the dropdown (menuRef)
        if (
            ConditionsRef.current &&
            !ConditionsRef.current.contains(event.target as Node) &&
            ConditionsBtnRef.current &&
            !ConditionsBtnRef.current.contains(event.target as Node)
        ) {
            setConditionToggle(false); // Close the dropdown if clicked outside
        }
    };

    useEffect(() =>{
    const container = conditonsContainerRef.current;
    if (container) {
        container.scrollTop = container.scrollHeight;
    }
    },[local_Cond_name, newconditionsArr, conditionToggle]);
    
    useEffect(() => {
            // Attach the click event listener to the document
            document.addEventListener("click", SavedConditionshandleClickOutside);
            document.addEventListener("click", ConditionshandleClickOutside);
            // Cleanup the event listener when the component unmounts
        return () => {
            document.addEventListener("click", SavedConditionshandleClickOutside);
            document.addEventListener("click", ConditionshandleClickOutside);
        };
    }, []);

  const isSaveBtnDisabled = (btn_name: string) => {
    if(local_Cond_name === ""){
      return newconditionsArr?.some(
        (item) =>
          item?.metric === "" ||
          item?.parameter === "" ||
          item?.Operation === "" ||
          item?.initial_value === ""
      );
    } else if(local_Cond_name !== ""){
      if(btn_name === "save"){
        return !isDbDataChanges && newconditionsArr?.length === 0;
      }
    }
  }
  return (
        <div className="flex flex-col items-start self-stretch " >
              <div className="px-3 flex flex-col items-start gap-3 self-stretch">
                <div
                  className="flex px-4 py-2 min-h-[40px] justify-between items-center gap-2 self-stretch rounded-[4px]"
                  style={{
                    border: "1px solid #EAEAED",
                    position: "relative",
                  }}
                >
                  <div className="flex gap-2 items-start flex-wrap">
                    {conditionsArr &&
                      conditionsArr.length > 0 &&
                      conditionsArr.map((condition, i) => (
                        <div
                          className="flex h-[28px] p-2 items-center gap-2 rounded-[4px]"
                          style={{
                            backgroundColor: "#F2F2F5",
                          }}
                          key={i}
                        >
                          <div
                            style={{
                              color: "var(--Text-Primary-Grey, #97979A)",
                              fontFamily: "Inter",
                              fontSize: "8px",
                              fontStyle: "normal",
                              fontWeight: 500,
                              lineHeight: "8px", // 100%
                              letterSpacing: "1.6px",
                              textTransform: "uppercase",
                              textWrap: "nowrap",
                            }}
                          >
                            {condition?.dependent_value === ""
                              ? `${
                                  matricsArr.find(
                                    (m) =>
                                      m?.backend_matrice_name ===
                                      condition?.metric
                                  )?.matrice_name
                                } ${
                                  condition?.parameter === "current"
                                    ? "Current Period"
                                    : condition?.parameter === "previous"
                                    ? "Comparison Period"
                                    : condition?.parameter === "difference"
                                    ? "Difference"
                                    : "Difference %"
                                } ${condition?.Operation} ${
                                  condition?.initial_value
                                }`
                              : `${
                                  matricsArr.find(
                                    (m) =>
                                      m?.backend_matrice_name ===
                                      condition?.metric
                                  )?.matrice_name
                                } ${
                                  condition?.parameter === "current"
                                    ? "Current Period"
                                    : condition?.parameter === "previous"
                                    ? "Comparison Period"
                                    : condition?.parameter === "difference"
                                    ? "Difference"
                                    : "Difference %"
                                } ${condition?.Operation} ${
                                  condition?.initial_value
                                } - ${condition?.dependent_value}`}
                          </div>
                          <div
                            className="flex w-4 h-4 p-[1.33px] justify-center items-center cursor-pointer"
                            onClick={() => {
                              setConditionsArr((prev) => {
                                if (prev.length === 1) {
                                  ClearAll();
                                  return [];
                                } else {
                                  return prev.filter(
                                    (item) =>
                                      !(
                                        item.metric === condition.metric &&
                                        item.parameter ===
                                          condition.parameter &&
                                        item.Operation ===
                                          condition.Operation &&
                                        item.initial_value ===
                                          condition.initial_value &&
                                        item.dependent_value ===
                                          condition.dependent_value
                                      )
                                  );
                                }
                              });
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              <path
                                d="M9.99957 10L6 6M6.00043 10L10 6"
                                stroke="#97979A"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M14.6663 7.99999C14.6663 4.31809 11.6816 1.33332 7.99967 1.33332C4.31778 1.33332 1.33301 4.31809 1.33301 7.99999C1.33301 11.6819 4.31778 14.6667 7.99967 14.6667C11.6816 14.6667 14.6663 11.6819 14.6663 7.99999Z"
                                stroke="#97979A"
                                stroke-width="1.5"
                              />
                            </svg>
                          </div>
                        </div>
                      ))}
                    <div
                      className="w-fit h-[28px] flex justify-center items-center"
                      style={{
                        color: "var(--Text-Primary-Grey, #1C1C1E)",
                        fontFamily: "Inter, sans-serif",
                        fontSize: "8px",
                        fontStyle: "normal",
                        fontWeight: 600,
                        lineHeight: "8px", // 100%
                        letterSpacing: "1.6px",
                        textTransform: "uppercase",
                        cursor: "pointer",
                      }}
                      ref={ConditionsBtnRef}
                      onClick={() => setConditionToggle((prev) => !prev)}
                    >
                      Add Condition...
                    </div>
                  </div>

                  <div
                    className="flex py-[2px] justify-center items-center gap-2 cursor-pointer"
                    onClick={() => {
                      if(conditionsArr?.length > 0){
                        setConditionsArr([]);
                        ClearAll();
                      }
                    }}
                  >
                    <div
                      style={{
                        color:
                          conditionsArr.length > 0
                            ? "#D10C00"
                            : "var(--Text-Primary-Disabled, #1C1C1E)",
                        textAlign: "center",
                        fontFamily: "Inter, sans-serif",
                        fontSize: "12px",
                        fontStyle: "normal",
                        fontWeight: 700,
                        lineHeight: "18px", // Button/Small
                        textWrap: "nowrap",
                      }}
                    >
                      Clear All
                    </div>
                  </div>

                  {conditionToggle && (
                    <div
                      className="absolute top-[56px] left-0 bg-slate-400 w-[696px] flex flex-col items-start rounded-2"
                      style={{
                        zIndex: 10,
                        backgroundColor: "#FFF",
                        boxShadow: "0px 4px 10px 4px rgba(28,28,30,0.05)",
                      }}
                      ref={ConditionsRef}
                    >
                      <div
                        className="flex p-4 justify-between items-center self-stretch "
                        style={{
                          borderBottom: "1px solid #EAEAED",
                        }}
                      >
                        <div className="flex items-center gap-2">
                          <div
                            style={{
                              color: "var(--Text-Primary-Black, #1C1C1E)",
                              fontFamily: "Inter",
                              fontSize: "16px",
                              fontStyle: "normal",
                              fontWeight: 700,
                              lineHeight: "20px",
                            }}
                          >
                            {/* Your content here */}
                            Conditions
                          </div>
                          <div className="relative">
                            <div
                              className="relative flex w-[380px] h-[28px] items-center justify-between rounded-[4px] px-4 cursor-pointer"
                              style={{
                                border: "1px solid #EAEAED",
                              }}
                              ref={SavedConditionsBtnRef}
                              onClick={() =>
                                setLocalCondToggle(!localCondToggle)
                              }
                            >
                              <div
                                style={{
                                  color: local_Cond_name
                                    ? "#1C1C1E"
                                    : "var(--Text-Primary-Grey, #97979A)",
                                  fontFamily: "Inter",
                                  fontSize: "10px",
                                  fontStyle: "normal",
                                  fontWeight: 400,
                                  lineHeight: "14px",
                                }}
                              >
                                {local_Cond_name
                                  ? local_Cond_name
                                  : "Saved Conditions"}
                              </div>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                              >
                                <path
                                  d="M9.56283 12.0625L6.54199 9.04168C6.50033 9.00001 6.46908 8.95487 6.44824 8.90626C6.42741 8.85765 6.41699 8.80557 6.41699 8.75001C6.41699 8.6389 6.45519 8.54168 6.53158 8.45834C6.60796 8.37501 6.70866 8.33334 6.83366 8.33334H13.167C13.292 8.33334 13.3927 8.37501 13.4691 8.45834C13.5455 8.54168 13.5837 8.6389 13.5837 8.75001C13.5837 8.77779 13.542 8.87501 13.4587 9.04168L10.4378 12.0625C10.3684 12.132 10.2989 12.1806 10.2295 12.2083C10.16 12.2361 10.0837 12.25 10.0003 12.25C9.91699 12.25 9.8406 12.2361 9.77116 12.2083C9.70171 12.1806 9.63227 12.132 9.56283 12.0625Z"
                                  fill="#1C1C1E"
                                />
                              </svg>
                            </div>
                            {localCondToggle && (
                              <div
                                className="custom-scrollbar py-2 flex w-full max-h-[216px] flex-col items-start rounded-[8px]"
                                style={{
                                  position: "absolute",
                                  top: 30,
                                  right: 0,
                                  backgroundColor: "white",
                                  boxShadow:
                                    "0px 4px 10px 4px rgba(28, 28, 30, 0.05)",
                                  zIndex: 10000,
                                  overflowY: "auto",
                                }}
                                ref={SavedConditionsRef}
                              >
                                <style>
                                  {`
                                .custom-scrollbar::-webkit-scrollbar {
                                    width: 6px;
                                    height: 50px;
                                    
                                }

                                .custom-scrollbar::-webkit-scrollbar-track {
                                    background: white;
                                }

                                .custom-scrollbar::-webkit-scrollbar-thumb {
                                    background: #F2F2F5;
                                    border-radius: 8px;
                                }

                                `}
                                </style>
                                {listarr && listarr.length > 0 ? (
                                  listarr?.map((list: ListProps) => (
                                    <div
                                      className="flex h-[52px] p-4 items-center gap-2 self-stretch cursor-pointer"
                                      key={list?.condition_name}
                                      onClick={(event) => {
                                        event.stopPropagation();
                                        setLocalConditions(
                                          list?.condition_array
                                        );
                                        setLocalCondToggle(false);
                                        setlocal_Cond_name(
                                          list?.condition_name
                                        );
                                        setNewConditionsArr([]);
                                        setlocal_Cond_id(list?.condition_id);
                                      }}
                                    >
                                      <div
                                        style={{
                                          color: "#1C1C1E",
                                          fontSize: "14px",
                                          fontWeight:
                                            local_Cond_name ===
                                            list?.condition_name
                                              ? "500"
                                              : "400",
                                          lineHeight: "18px",
                                        }}
                                      >
                                        {list?.condition_name}
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <div className="flex h-[52px] p-4 items-center justify-center gap-2 self-stretch cursor-pointer">
                                    <div
                                      style={{
                                        color: "#1C1C1E",
                                        fontSize: "14px",
                                        fontWeight: "400",
                                        lineHeight: "18px",
                                        textAlign: "center",
                                      }}
                                    >
                                      No Data
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        </div>

                        <button
                          style={{
                            backgroundColor: "#FFF",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "8px",
                          }}
                          onClick={() => {
                            ClearAll();
                            setIsDbDataChanges(false);
                          }}
                        >
                          <div
                            style={{
                              color:
                                localconditions.length > 0
                                  ? "#D10C00"
                                  : "var(--Text-Primary-Disabled, #B7B7B9)",
                              textAlign: "center",
                              fontFamily: "Inter",
                              fontSize: "12px",
                              fontStyle: "normal",
                              fontWeight: 700,
                              lineHeight: "18px",
                            }}
                          >
                            Clear All
                          </div>
                        </button>
                      </div>

                      <div className="w-full flex p-4 flex-col items-start gap-6">
                        <div className="w-full flex flex-col items-start gap-2">
                          <div className="w-full flex flex-col gap-2 h-[210px] overflow-auto " 
                          ref={conditonsContainerRef}>
                            {localconditions.length > 0 &&
                              localconditions.map((cond, i) => (
                                <CondCmpForDbData
                                  index={i}
                                  cond={cond}
                                  key={i}
                                  matricsArr={matricsArr}
                                  newcondition={newcondition}
                                  setNewCondition={setNewCondition}
                                  parameterArr={parameterArr}
                                  operationsArr={operationsArr}
                                  localConditionsLength={
                                    localconditions?.length
                                  }
                                  setLocalConditions={setLocalConditions}
                                  setNewConditionsArr={setNewConditionsArr}
                                  setIsDbDataChanges={setIsDbDataChanges}
                                />
                              ))}

                            {newconditionsArr.length > 0 &&
                              newconditionsArr.map((cond, i) => (
                                <CondCmpForCreate
                                  index={i}
                                  cond={cond}
                                  key={i}
                                  matricsArr={matricsArr}
                                  parameterArr={parameterArr}
                                  operationsArr={operationsArr}
                                  localConditionsLength={
                                    localconditions?.length
                                  }
                                  newconditionsArr={newconditionsArr}
                                  setLocalConditions={setNewConditionsArr}
                                />
                              ))}
                          </div>

                          <div
                            className="flex py-1 justify-center items-center gap-2"
                            onClick={() => {
                              const CheckvalueEmpty = newconditionsArr.some(
                                (item) =>
                                  item?.metric === "" ||
                                  item?.parameter === "" ||
                                  item?.Operation === "" ||
                                  item?.initial_value === ""
                              );
                              
                              if(CheckvalueEmpty && newconditionsArr?.length > 0){
                                setNewConditionsArr((prev) =>
                                  prev.map((item) => ({
                                    ...item,
                                    metric_error:
                                      item.metric === "" ? true : false,
                                    parameter_error:
                                      item.parameter === "" ? true : false,
                                    Operation_error:
                                      item.Operation === "" ? true : false,
                                    initial_value_error:
                                      item.initial_value === ""
                                        ? true
                                        : false,
                                    dependent_value_error:
                                      item.dependent_value === ""
                                        ? true
                                        : false,
                                  }))
                                );
                                appError("Please Enter all Fields");
                                return;
                              } else {
                                setNewConditionsArr((prev) => [
                                  ...prev.map(item => ({
                                    ...item,
                                    metric_error:
                                      item.metric === "" ? true : false,
                                    parameter_error:
                                      item.parameter === "" ? true : false,
                                    Operation_error:
                                      item.Operation === "" ? true : false,
                                    initial_value_error:
                                      item.initial_value === ""
                                        ? true
                                        : false,
                                    dependent_value_error:
                                      item.dependent_value === ""
                                        ? true
                                        : false,
                                  })),
                                  {
                                    metric: "",
                                    parameter: "",
                                    Operation: "",
                                    initial_value: "",
                                    dependent_value: "",
                                  },
                                ]);
                              }
                            }}
                          >
                            <div className="flex py-1 gap-2 justify-center items-center cursor-pointer">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                              >
                                <path
                                  d="M9.00033 5.66663V12.3333M12.3337 8.99996L5.66699 8.99996"
                                  stroke="#1565C0"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M1.0835 8.99998C1.0835 5.26803 1.0835 3.40205 2.24287 2.24268C3.40223 1.08331 5.26821 1.08331 9.00016 1.08331C12.7321 1.08331 14.5981 1.08331 15.7575 2.24268C16.9168 3.40205 16.9168 5.26803 16.9168 8.99998C16.9168 12.7319 16.9168 14.5979 15.7575 15.7573C14.5981 16.9166 12.7321 16.9166 9.00016 16.9166C5.26821 16.9166 3.40223 16.9166 2.24287 15.7573C1.0835 14.5979 1.0835 12.7319 1.0835 8.99998Z"
                                  stroke="#1565C0"
                                  stroke-width="1.5"
                                />
                              </svg>
                              <div
                                style={{
                                  color: "var(--Text-Event-Blue, #1565C0)",
                                  textAlign: "center",
                                  fontFamily: "Inter",
                                  fontSize: "12px",
                                  fontStyle: "normal",
                                  fontWeight: 700,
                                  lineHeight: "18px",
                                }}
                              >
                                {/* Your content here */}
                                Add More Conditions
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="w-full flex justify-between items-center self-stretch">
                          <Button
                            // loading={lodingOnSave}
                            disabled={isSaveBtnDisabled("save")}
                            sx={{
                              height: 32,
                              width: "120px",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: 12,
                              fontWeight: 700,
                              backgroundColor: "#FFF",
                              lineHeight: "18px",
                              color: "black",
                              borderRadius: 4,
                              paddingY: "0px",
                              border: "1px solid #EAEAED",
                              ":hover": {
                                backgroundColor: "#FFF",
                              },
                            }}
                            onClick={() => {
                              if (local_Cond_name === "") {
                                const CheckvalueEmpty = newconditionsArr.some(
                                  (item) =>
                                    item?.metric === "" ||
                                    item?.parameter === "" ||
                                    item?.Operation === "" ||
                                    item?.initial_value === ""
                                );
                                    if (CheckvalueEmpty) {
                                      setNewConditionsArr((prev) =>
                                          prev.map((item) => ({
                                          ...item,
                                          metric_error:
                                              item.metric === "" ? true : false,
                                          parameter_error:
                                              item.parameter === "" ? true : false,
                                          Operation_error:
                                              item.Operation === "" ? true : false,
                                          initial_value_error:
                                              item.initial_value === ""
                                              ? true
                                              : false,
                                          dependent_value_error:
                                              item.dependent_value === ""
                                              ? true
                                              : false,
                                          }))
                                      );
                                      appError("Please Enter all Fields");
                                      return;
                                    } else {
                                      setSaveConditionToggle(true);
                                      setConditionToggle(false);
                                    }
                              } else {
                                const CheckvalueEmpty = newconditionsArr.some(
                                  (item) =>
                                    item?.metric === "" ||
                                    item?.parameter === "" ||
                                    item?.Operation === "" ||
                                    item?.initial_value === ""
                                );
                                if (CheckvalueEmpty) {
                                  setNewConditionsArr((prev) =>
                                    prev.map((item) => ({
                                      ...item,
                                      metric_error:
                                        item.metric === "" ? true : false,
                                      parameter_error:
                                        item.parameter === "" ? true : false,
                                      Operation_error:
                                        item.Operation === "" ? true : false,
                                      initial_value_error:
                                        item.initial_value === ""
                                          ? true
                                          : false,
                                      dependent_value_error:
                                        item.dependent_value === ""
                                          ? true
                                          : false,
                                    }))
                                  );
                                  appError("Please Enter all Fields");
                                  return;
                                } else {
                                  setConfirmConditionToggle(true);
                                  setConditionToggle(false);
                                }
                              }
                            }}
                          >
                            Save Condition
                          </Button>
                          <div className="flex gap-4">
                            <Button
                              // loading={lodingOnSave}
                              sx={{
                                height: 32,
                                width: "120px",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: 12,
                                fontWeight: 700,
                                backgroundColor: "#FFF",
                                lineHeight: "18px",
                                color: "black",
                                borderRadius: 4,
                                paddingY: "0px",
                                border: "1px solid #EAEAED",
                                ":hover": {
                                  backgroundColor: "#FFF",
                                },
                              }}
                              onClick={() => {
                                setConditionToggle(false);
                                ClearAll();
                              }}
                            >
                              Cancel
                            </Button>
                            <Button
                              disabled={isSaveBtnDisabled("apply")}

                              sx={{
                                height: 32,
                                width: "120px",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: 12,
                                fontWeight: 700,
                                backgroundColor: "#1565C0",
                                lineHeight: "18px",
                                color: "#FFF",
                                borderRadius: 4,
                                paddingY: "0px",
                              }}
                              onClick={() => {
                                const CheckvalueEmpty = newconditionsArr.some(
                                  (item) =>
                                    item?.metric === "" ||
                                    item?.parameter === "" ||
                                    item?.Operation === "" ||
                                    item?.initial_value === ""
                                );

                                if (CheckvalueEmpty && newconditionsArr?.length > 0) {
                                  setNewConditionsArr((prev) =>
                                    prev.map((item) => ({
                                      ...item,
                                      metric_error:
                                        item.metric === "" ? true : false,
                                      parameter_error:
                                        item.parameter === "" ? true : false,
                                      Operation_error:
                                        item.Operation === "" ? true : false,
                                      initial_value_error:
                                        item.initial_value === ""
                                          ? true
                                          : false,
                                      dependent_value_error:
                                        item.dependent_value === ""
                                          ? true
                                          : false,
                                    }))
                                  );
                                  appError("Please Enter all Fields");
                                  return;
                                } else {
                                  setConditionToggle(false);
                                  let temp_arr = newconditionsArr.filter(
                                    (cond) =>
                                      cond?.metric !== "" &&
                                      cond?.parameter !== "" &&
                                      cond?.Operation !== "" &&
                                      cond?.initial_value !== ""
                                  );
                                  if(temp_arr?.length > 0){
                                    setConditionsArr([
                                      ...localconditions,
                                      ...temp_arr,
                                    ]);
                                  }
                                  else {
                                    setConditionsArr([...localconditions]);
                                    setNewConditionsArr([{
                                      metric: "",
                                      parameter: "",
                                      Operation: "",
                                      initial_value: "",
                                      dependent_value: "",
                                    },])
                                  }
                                }
                              }}
                            >
                              Apply
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {saveConditionToggle && (
                    <div
                      className="absolute top-[56px] left-0 bg-slate-400 w-[696px] flex flex-col items-start rounded-2"
                      style={{
                        zIndex: 10,
                        backgroundColor: "#FFF",
                        boxShadow: "0px 4px 10px 4px rgba(28,28,30,0.05)",
                      }}
                    >
                      <div
                        className="flex p-4 justify-between items-center self-stretch "
                        style={{
                          borderBottom: "1px solid #EAEAED",
                        }}
                      >
                        <div className="flex items-center gap-2">
                          <div
                            style={{
                              color: "var(--Text-Primary-Black, #1C1C1E)",
                              fontFamily: "Inter",
                              fontSize: "16px",
                              fontStyle: "normal",
                              fontWeight: 700,
                              lineHeight: "20px",
                            }}
                          >
                            Save
                          </div>
                        </div>
                      </div>

                      <div className="w-full flex p-4 flex-col items-start gap-6">
                        <div className="flex flex-col items-start gap-2 self-stretch">
                          <div
                            style={{
                              color: "var(--Text-Primary-Black, #1C1C1E)",
                              fontFamily: "Inter",
                              fontSize: "14px",
                              fontStyle: "normal",
                              fontWeight: 500,
                              lineHeight: "18px",
                            }}
                          >
                            Custom Condition Name
                          </div>

                          <Input
                            placeholder="Name Your Custom Conditions"
                            sx={{
                              "--Input-focusedThickness": "0px",
                              width: "100%",
                              height: "36px",
                              paddingY: "8px",
                              paddingX: "16px",
                              fontSize: "12px",
                              fontWeight: "400",
                              lineHeight: "18px",
                              backgroundColor: "#FFF",
                              "&.Mui-disabled": {
                                backgroundColor: "#F3F3F7",
                              },
                              borderRadius: "8px",
                              border: "1px solid #EAEAED",
                            }}
                            name="list_name"
                            value={temp_list_name}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => setTemp_List_name(e.target.value)}
                          />
                          {temp_list_name_error && (
                            <div className="flex items-center gap-1 self-stretch">
                              <div className="flex w-4 h-4 p-[1.33px] justify-center items-center">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                >
                                  <circle
                                    cx="7.99967"
                                    cy="7.99967"
                                    r="6.66667"
                                    stroke="#D10C00"
                                    stroke-width="1.5"
                                  />
                                  <path
                                    d="M7.99401 10H8"
                                    stroke="#D10C00"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M8 8L8 5.33333"
                                    stroke="#D10C00"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                              </div>
                              <div
                                style={{
                                  color: "var(--Text-Event-Red, #D10C00)",
                                  fontFamily: "Inter",
                                  fontSize: "12px",
                                  fontStyle: "normal",
                                  fontWeight: 500,
                                  lineHeight: "18px",
                                }}
                              >
                                Condition name already exists
                              </div>
                            </div>
                          )}
                        </div>

                        <div className="w-full flex justify-between items-center self-stretch">
                          <Button
                            // loading={lodingOnSave}
                            sx={{
                              height: 32,
                              width: "120px",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: 12,
                              fontWeight: 700,
                              backgroundColor: "#FFF",
                              lineHeight: "18px",
                              color: "black",
                              borderRadius: 4,
                              paddingY: "0px",
                              border: "1px solid #EAEAED",
                              ":hover": {
                                backgroundColor: "#FFF",
                              },
                            }}
                            onClick={(event) => {
                              event.stopPropagation();
                              setSaveConditionToggle(false);
                              setConditionToggle((prev) => !prev);
                            }}
                          >
                            Back
                          </Button>
                          <div className="flex gap-4">
                            <Button
                              // loading={lodingOnSave}
                              sx={{
                                height: 32,
                                width: "120px",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: 12,
                                fontWeight: 700,
                                backgroundColor: "#FFF",
                                lineHeight: "18px",
                                color: "black",
                                borderRadius: 4,
                                paddingY: "0px",
                                border: "1px solid #EAEAED",
                                ":hover": {
                                  backgroundColor: "#FFF",
                                },
                              }}
                              onClick={() => {
                                setTemp_List_name("");
                                setSaveConditionToggle(false);
                              }}
                            >
                              Cancel
                            </Button>
                            <Button
                              loading={conditonsSave}
                              disabled={temp_list_name===""}
                              sx={{
                                height: 32,
                                width: "120px",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: 12,
                                fontWeight: 700,
                                backgroundColor: "#1565C0",
                                lineHeight: "18px",
                                color: "#FFF",
                                borderRadius: 4,
                                paddingY: "0px",
                              }}
                              onClick={() => {
                                if (temp_list_name === "") {
                                  setTemp_list_name_error(true);
                                  return;
                                }
                                else {
                                  if(listarr?.find(item => item?.condition_name === temp_list_name)){
                                    appError("Please enter Unique Condition List Name");
                                    return;
                                  }
                                  else {
                                    setIsDbDataChanges(false);
                                    createConditionLists();
                                  }
                                }
                              }}
                            >
                              Save
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
  )
}

export default ConditionCompCmp